import React, { Component } from "react";
import { withTranslation } from "react-i18next";

class LocationText2 extends Component {
  state = {};
  render() {
    const { t } = this.props;
    return (
      <section>
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div
              className="col-12 col-lg-12 col-md-12  wow animate__fadeInLeft"
              data-wow-delay="0.5s"
              style={{
                visibility: "visible",
                animationDelay: "0.5s",
                animationName: "fadeInLeft",
              }}
            >
              <h5 className="alt-font font-weight-600 text-extra-dark-gray w-95">
                {t("title69")}
                <br></br>
                {t("title70")}
                <br></br>
                <br></br>
                {t("title71")}
              </h5>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withTranslation("general")(LocationText2);
